import React, { createContext, useContext, useState, ReactNode } from 'react';
import { motion } from 'framer-motion';

interface PopupContextType {
  showPopup: (popupContent: ReactNode) => void;
  hidePopup: () => void;
}

const PopupContext = createContext<PopupContextType | undefined>(undefined);

export const usePopup = () => {
  const context = useContext(PopupContext);
  if (!context) {
    throw new Error('usePopup must be used within a PopupProvider');
  }
  return context;
};

export const PopupProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [popupContent, setPopupContent] = useState<ReactNode>(null);

  const showPopup = (content: ReactNode) => {
    setPopupContent(content);
    setIsOpen(true);
  };

  const hidePopup = () => {
    setIsOpen(false);
    setPopupContent(null);
  };

  return (
    <PopupContext.Provider value={{ showPopup, hidePopup }}>
      {children}
      {isOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 200, // POPUP_CONTEXT_ZINDEX
          }}
          onClick={hidePopup}
        >
          <motion.div
            style={{
              maxWidth: '320px',
              textAlign: 'center',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            onClick={(e) => e.stopPropagation()}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
            transition={{ duration: 0.3 }}
          >
            {popupContent}
            {/* <button onClick={hidePopup}>Close</button> */}
          </motion.div>
        </div>
      )}
    </PopupContext.Provider>
  );
};
